import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import NoteCard from "../components/NoteCard";
import EmptyState from "../components/EmptyState";
import LoadingSkeleton from "../components/LoadingSkeleton";
import api from "../services/api";
import { FiBook, FiFileText, FiBookOpen, FiPlus, FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    totalNotes: 0,
    pastPapers: 0,
    subjects: 0,
  });

  const [recentNotes, setRecentNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);

      const userData = JSON.parse(localStorage.getItem("user"));
      const collegeId = userData?.collegeId;

      const endpoint = collegeId ? `/notes?college=${collegeId}&limit=6` : '/notes?limit=6';
      const notes = await api.get(endpoint);

      setRecentNotes(notes || []);

      const pastPapers = (notes || []).filter((note) => note.type === "pastpaper").length;
      const uniqueSubjects = [...new Set((notes || []).map((note) => note.subject))].length;

      setStats({
        totalNotes: (notes || []).length,
        pastPapers,
        subjects: uniqueSubjects,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar onLogout={onLogout} />

      <div className="main-content">
        <Header
          title={`Good morning, ${user?.name ? user.name.split(" ")[0] : "User"}`}
          subtitle="Here is an overview of your college study workspace and recent materials."
        />

        {/* Stats Grid */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon-wrapper note">
              <FiBook />
            </div>
            <div className="stat-details">
              <h4>Total Notes</h4>
              <div className="stat-value">{stats.totalNotes}</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon-wrapper paper">
              <FiFileText />
            </div>
            <div className="stat-details">
              <h4>Past Exam Papers</h4>
              <div className="stat-value">{stats.pastPapers}</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon-wrapper subject">
              <FiBookOpen />
            </div>
            <div className="stat-details">
              <h4>Active Subjects</h4>
              <div className="stat-value">{stats.subjects}</div>
            </div>
          </div>
        </div>

        {/* Recent Uploads Section */}
        <div className="card">
          <div className="d-flex justify-between align-center mb-4">
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: '600' }}>Recent Uploads</h2>
              <p className="text-secondary text-sm">Latest study resources uploaded to your institution</p>
            </div>
            <button onClick={() => navigate("/notes")} className="btn btn-ghost btn-sm">
              View Library <FiArrowRight />
            </button>
          </div>

          {loading ? (
            <LoadingSkeleton type="card" count={3} />
          ) : recentNotes.length > 0 ? (
            <div className="notes-grid">
              {recentNotes.map((note) => (
                <NoteCard key={note._id} note={note} onDeleteSuccess={fetchDashboardData} />
              ))}
            </div>
          ) : (
            <EmptyState
              icon={<FiBook />}
              title="No study materials available yet"
              description="Be the first to contribute notes or past papers to your institution's library."
              actionButton={
                <button onClick={() => navigate("/upload")} className="btn btn-primary">
                  <FiPlus /> Upload Note
                </button>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;